import React, { useEffect } from 'react';
import { ThemeProvider as Provider } from 'react-jss';
import { Theme } from './Theme';
import FontLoader from 'webfontloader';
import { DimensionsProvider } from '../../context/DimensionsContext';
export const ThemeProvider = ({ theme = Theme, children }) => {
    useEffect(() => {
        FontLoader.load({
            google: { families: ['Ubuntu:300,400,500,700'] }
        });
    }, []);
    return (React.createElement(Provider, { theme: theme },
        React.createElement(DimensionsProvider, null, children)));
};
//# sourceMappingURL=Provider.js.map